var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1 96a23 23 0 1 0 0-46 23 23 0 0 0 0 46Zm0-13.4a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2ZM23 50a23 23 0 1 0 0-46.2A23 23 0 0 0 23 50Zm0-13.5a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 13,
    d: "M82.4 4 11.8 94.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentIcon);
export default __webpack_public_path__ + "static/media/percent_icon.5f19d60c3448797e21cd8016ae7146e5.svg";
export { ForwardRef as ReactComponent };